import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'zagops-logo',
  standalone: true,
  imports: [RouterModule],
  template: `
    <a class="app-logo">
      <svg
        viewBox="0 0 3053.7 855.8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="app-logo-normal"
      >
        <path
          d="M289.6 703.07v111.68h-24.61V703.07h24.61ZM349.38 703.07l47.48 77.61h.32v-77.61h24.61v111.68h-32.18l-48.74-79.5h-.32v79.5h-24.61V703.07h33.44ZM526.53 703.07v21.77h-31.86v89.92h-24.61v-89.92H438.2v-21.77h88.34ZM619.75 703.07v22.71h-51.27v20.82h48.43v22.72h-48.43v22.72h54.11v22.71h-78.71V703.07h75.88ZM690.26 703.07c20.19 0 41.33 6.78 41.33 33.92 0 16.41-8.99 27.76-24.13 30.6l28.39 47.17h-29.5L683 770.12h-12.15v44.64h-24.61V703.08h44.01Zm-4.1 46.22c11.36 0 19.88-1.89 19.88-12.46 0-9.15-6.78-12.94-18.46-12.94h-16.72v25.4h15.3ZM866.93 758.91c0 35.49-25.24 58.68-60.26 58.68s-60.26-23.03-60.26-58.68 25.08-58.68 60.26-58.68 60.26 23.19 60.26 58.68Zm-60.25 35.97c20.82 0 34.7-14.99 34.7-35.97s-13.88-35.97-34.86-35.97-34.55 14.83-34.55 35.97 13.72 35.97 34.7 35.97ZM929.87 703.07c26.82 0 41.65 10.88 41.65 33.92s-14.83 34.23-40.54 34.23h-18.77v43.54H887.6V703.08h42.28Zm-.79 47.33c9.78 0 16.88-4.26 16.88-13.41 0-8.68-6.63-13.09-20.51-13.09H912.2v26.5h16.88ZM1067.74 703.07v22.71h-51.27v20.82h48.43v22.72h-48.43v22.72h54.11v22.71h-78.71V703.07h75.88ZM1138.25 703.07c20.19 0 41.33 6.78 41.33 33.92 0 16.41-8.99 27.76-24.13 30.6l28.39 47.17h-29.5l-23.35-44.64h-12.15v44.64h-24.61V703.08h44.01Zm-4.1 46.22c11.36 0 19.88-1.89 19.88-12.46 0-9.15-6.78-12.94-18.46-12.94h-16.72v25.4h15.3ZM1257.5 703.07l48.59 111.68h-27.76l-9.62-23.66h-43.38l-9.31 23.66h-27.13l48.27-111.68h20.35Zm-24.45 67.2h27.29l-13.72-34.7-13.57 34.7ZM1363.82 703.07c19.72 0 39.91 4.89 39.91 28.39 0 12.46-7.73 20.98-19.24 24.61v.32c13.09 1.58 24.45 11.36 24.45 27.29 0 23.35-22.08 31.08-41.8 31.08h-45.9V703.08h42.59Zm.32 44.64c7.57 0 14.99-3.63 14.99-12.15 0-8.99-8.52-11.67-16.09-11.67h-17.19v23.82h18.3Zm4.26 46.22c8.04 0 15.93-4.1 15.93-13.09 0-10.25-11.2-12.3-19.24-12.3h-19.25v25.4h22.56ZM1451.68 703.07v111.68h-24.61V703.07h24.61ZM1503.58 703.07v88.97h45.59v22.71h-70.2V703.07h24.61ZM1590.97 703.07v111.68h-24.61V703.07h24.61ZM1695.39 703.07v21.77h-31.86v89.92h-24.61v-89.92h-31.86v-21.77h88.34ZM1727.89 703.07l23.66 41.8 25.08-41.8h29.18l-41.96 64.04v47.64h-24.61v-47.64l-41.96-64.04h30.6ZM1940.68 711.91l-16.88 18.46c-3.94-5.05-11.83-7.41-17.83-7.41-6.78 0-16.56 3.15-16.56 11.52 0 9.78 11.83 11.83 24.14 15.62 13.41 4.1 27.29 10.57 27.29 30.76 0 25.4-20.35 36.75-43.06 36.75-14.36 0-26.97-4.1-37.54-14.04l17.51-19.25c5.21 6.63 13.09 10.57 21.45 10.57 6.78 0 17.04-3 17.04-11.67 0-9.78-11.83-12.3-24.29-16.41-13.72-4.42-28.08-10.73-28.08-30.29 0-23.82 20.82-36.28 42.59-36.28 12.46 0 24.61 3.31 34.23 11.67ZM2077.6 758.91c0 35.49-25.24 58.68-60.26 58.68s-60.26-23.03-60.26-58.68 25.08-58.68 60.26-58.68 60.26 23.19 60.26 58.68Zm-60.26 35.97c20.82 0 34.7-14.99 34.7-35.97s-13.88-35.97-34.86-35.97-34.55 14.83-34.55 35.97 13.72 35.97 34.7 35.97ZM2123.82 703.07v88.97h45.59v22.71h-70.2V703.07h24.61ZM2211.52 703.07v67.99c0 13.25 9.46 23.82 22.56 23.82 11.67 0 22.4-9.31 22.4-23.82v-67.99h24.61v69.09c0 24.29-14.83 45.43-47.01 45.43s-47.17-21.14-47.17-45.43v-69.09h24.61ZM2385.83 703.07v21.77h-31.86v89.92h-24.61v-89.92h-31.86v-21.77h88.34ZM2426.52 703.07v111.68h-24.61V703.07h24.61ZM2567.39 758.91c0 35.49-25.24 58.68-60.26 58.68s-60.26-23.03-60.26-58.68 25.08-58.68 60.26-58.68 60.26 23.19 60.26 58.68Zm-60.26 35.97c20.82 0 34.7-14.99 34.7-35.97s-13.88-35.97-34.86-35.97-34.55 14.83-34.55 35.97 13.72 35.97 34.7 35.97ZM2621.49 703.07l47.48 77.61h.32v-77.61h24.61v111.68h-32.18l-48.74-79.5h-.32v79.5h-24.61V703.07h33.44ZM2792.64 711.91l-16.88 18.46c-3.94-5.05-11.83-7.41-17.83-7.41-6.78 0-16.56 3.15-16.56 11.52 0 9.78 11.83 11.83 24.14 15.62 13.41 4.1 27.29 10.57 27.29 30.76 0 25.4-20.35 36.75-43.06 36.75-14.36 0-26.97-4.1-37.54-14.04l17.51-19.25c5.21 6.63 13.09 10.57 21.45 10.57 6.78 0 17.04-3 17.04-11.67 0-9.78-11.83-12.3-24.29-16.41-13.72-4.42-28.08-10.73-28.08-30.29 0-23.82 20.82-36.28 42.59-36.28 12.46 0 24.61 3.31 34.23 11.67Z"
          fill="var(--menuitem-text-color)"
        />
        <path
          d="m226.98 343.98-105.3 91.85 308.88.58v60.84H29.25v-60.84l106.47-92.43h91.26Zm60.26-52.66h-91.26l163.8-142.15H34.52V87.74h396.04v78.39L287.23 291.32ZM581.49 343.98l283.73.59-104.71-198.32-77.22 145.08h-73.71L717.81 87.75h84.82l217.04 409.5h-74.29l-47.39-91.84H622.46l-47.39 91.84h-74.29l80.73-153.27ZM1137.24 135.13c40.95-36.27 92.81-54.4 155.61-54.4 76.05 0 138.25 32.57 186.61 97.7l-47.38 38.03c-20.68-29.25-42.12-49.04-64.35-59.38-22.23-10.33-48.76-15.5-79.56-15.5-43.68 0-80.35 12.68-109.98 38.03-34.32 29.25-51.48 67.67-51.48 115.24s14.82 81.9 44.46 109.98c28.86 28.47 67.86 42.71 117 42.71 76.43 0 125.97-34.9 148.59-104.71h-160.88v-59.67h232.24v5.85c0 65.91-20.09 118.96-60.25 159.12-40.57 40.56-93.8 60.84-159.71 60.84-60.06 0-110.77-17.94-152.1-53.82-46.02-40.95-69.03-94.38-69.03-160.29s23.4-118.36 70.2-159.71ZM1997.19 291.91c0 57.33-18.53 105.5-55.58 144.49-41.34 44.08-95.35 66.11-162.04 66.11s-120.51-22.23-162.63-66.69c-36.66-39.78-54.99-87.75-54.99-143.91S1580.28 187 1616.94 148c42.5-44.84 96.72-67.28 162.63-67.28s120.51 22.23 162.63 66.69c36.65 39 54.99 87.17 54.99 144.5Zm-66.69 0c0-45.63-14.24-81.9-42.7-108.81-27.3-27.29-63.38-40.95-108.23-40.95s-84.63 15.79-113.49 47.38c-25.36 27.7-38.02 61.82-38.02 102.38 0 44.08 14.42 80.14 43.29 108.22 27.69 27.7 63.77 41.54 108.23 41.54s81.31-13.65 108.23-40.95c28.46-26.91 42.7-63.18 42.7-108.81ZM2522.51 215.86c0 40.95-12.68 72.16-38.03 93.6-24.96 21.45-62.01 32.18-111.15 32.18h-243.36v155.61h-68.45V280.8h312.98c52.65 0 78.97-21.25 78.97-63.77 0-45.24-27.89-67.86-83.66-67.86h-239.85v78.39h-68.45V87.74l324.67.59c41.73 0 75.07 11.51 100.04 34.51 24.18 23.02 36.27 54.02 36.27 93.02ZM3033.8 372.64c0 42.91-19.3 76.44-57.92 100.62-38.23 23.79-93.6 35.69-166.14 35.69-97.9 0-175.31-20.08-232.25-60.26l25.74-57.91c63.96 39 132.99 58.5 207.09 58.5 48.35 0 85.6-6.63 111.73-19.89 25.35-12.87 38.03-30.42 38.03-52.65 0-25.74-16.58-43.09-49.73-52.06-17.55-4.29-64.35-8.97-140.4-14.04-68.25-4.68-115.64-13.65-142.16-26.91-31.98-15.59-47.97-42.31-47.97-80.14s18.13-69.03 54.41-91.26c35.48-22.23 86.38-33.35 152.68-33.35 81.9 0 151.51 17.55 208.84 52.65l-28.67 53.82c-60.46-30.8-122.26-46.21-185.44-46.21-42.51 0-74.69 4.88-96.53 14.62-22.23 9.75-33.34 23.4-33.34 40.95s11.89 31.01 35.68 39.2c16.38 6.24 44.07 10.53 83.07 12.87 56.94 3.51 94.38 6.43 112.32 8.77 52.26 7.02 90.28 19.7 114.07 38.03 24.57 18.72 36.86 45.04 36.86 78.97Z"
          fill="var(--logo-color)"
        />
      </svg>
      <svg
        width="21"
        height="22"
        viewBox="0 0 21 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="app-logo-small"
      >
        <path
          d="M10.4851 0L0 20.9465H3.53702L10.4856 6.07843L17.2944 20.9465H20.9715L10.4851 0Z"
          fill="var(--logo-color)"
        />
        <path
          d="M13.8399 15.793L16.2076 21.0019H11.7681L13.8399 15.793Z"
          fill="var(--logo-color)"
        />
        <path
          d="M9.04637 21.0019L6.67867 15.793L4.60693 21.0019H9.04637Z"
          fill="var(--logo-color)"
        />
      </svg>
    </a>
  `,
})
export class ZagOpsLogoComponent {}

interface AccountLogoScope {
  name?: string;
  logoUrl?: string;
}

@Component({
  selector: 'app-account-logo',
  standalone: true,
  imports: [AvatarModule, ZagOpsLogoComponent],
  template: `
    <!-- show account logo as avatar -->
    @if (variant === 'avatar') {
      <!-- use default logo -->
      @if (showDefaultLogo) {
        <p-avatar
          id="account-default-logo-avatar"
          [label]="accountLogoScope?.name ? accountLogoScope?.name?.[0] : ''"
          class="mr-2"
          shape="circle"
        />
      }
      <!-- use custom account logo -->
      @else {
        <p-avatar
          [image]="accountLogoScope?.logoUrl"
          id="account-custom-logo-avatar"
          class="mr-2"
          shape="circle"
          (onImageError)="handleMissingAccountLogo()"
        />
      }
    }
    <!-- show account logo as image -->
    @else if (variant === 'image') {
      <!-- use default logo -->
      @if (showDefaultLogo) {
        <zagops-logo id="account-default-logo-image" />
      }
      <!-- use custom account logo -->
      @else {
        <img
          [src]="accountLogoScope?.logoUrl"
          id="account-custom-logo-image"
          alt="selected-account-logo"
          class="w-32 h-32 rounded-xl"
          (error)="handleMissingAccountLogo()"
        />
      }
    }
  `,
})
export class AppAccountLogoComponent implements OnChanges {
  @Input() variant!: 'avatar' | 'image';
  @Input() accountLogoScope!: AccountLogoScope | null;

  accountLogoError = false;

  get showDefaultLogo(): boolean {
    return !this.accountLogoScope?.logoUrl?.length || this.accountLogoError;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['accountLogoScope']) {
      this.accountLogoError = false;
    }
  }

  handleMissingAccountLogo() {
    this.accountLogoError = true;
  }
}
